import { memo, FC } from "react";

export const Page404: FC = memo(() => {
  return <p>404 : ページが存在しません。</p>;
});